import * as React from 'react';
var useSafeTimeout = () => {
  var timer = React.useRef();
  React.useEffect(() => {
    return () => clearTimeout(timer.current);
  }, []);
  var setter = React.useCallback(function () {
    clearTimeout(timer.current);
    // eslint-disable-next-line no-restricted-syntax -- this is the one place we _can_ use it :)
    timer.current = setTimeout(...arguments);
  }, []);
  var clearer = React.useCallback(() => {
    clearTimeout(timer.current);
  }, []);
  return [setter, clearer];
};
export default useSafeTimeout;